export default __webpack_public_path__ + "static/media/Export.a8949345.svg";